














































import { Component, Prop, Watch } from 'vue-property-decorator';
import { GoalValueModel, IGoal } from 'admiral-core';
import { CalendarIcon, CircleIcon, DiscIcon, XIcon } from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';
import PolicyTimeline from '@/views/pages/policies/PolicyTimeline.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import PolicySelect from '@/components/common/selects/PolicySelect.vue';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import TaskForm from '@/forms/TaskForm.vue';
import { FormMixin } from '@/mixins/FormMixin';
import { BModal } from 'bootstrap-vue';
import GoalForm from '@/forms/GoalForm.vue';
import { GoalApi } from '@/services/GoalApi';
import GoalValueForm from '@/forms/GoalValueForm.vue';

@Component({
  components: {
    GoalValueForm,
    GoalForm,
    TaskForm,
    UserSelect,
    PolicySelect,
    PolicyTimeline,
    CircleIcon,
    DiscIcon,
    Multiselect,
    CalendarIcon,
    XIcon,
  },
})
export default class EditGoalValueModal extends mixins(BaseMixin, FormMixin) {
  @Prop({ type: Object })
  selectedGoal!: IGoal | null;

  model = this.defaultModel();
  isLoading2 = false;
  isDone2 = false;

  defaultModel(): GoalValueModel {
    return {
      value: this.selectedGoal?.value,
      valueType: this.selectedGoal?.valueType,
    };
  }

  @Watch('selectedGoal', { immediate: true })
  watchSelectedGoal() {
    this.model = {
      value: this.selectedGoal?.value,
      valueType: this.selectedGoal?.valueType,
    };
  }

  async mounted() {
    this.model = { ...this.defaultModel() };
  }

  async ok(evt: Event) {
    evt.preventDefault();
    try {
      this.isLoading = true;
      const response = await GoalApi.updateGoalValue(this.selectedGoal?.id!, {
        value: Number(this.model.value!),
      });
      this.model = { ...this.defaultModel() };
      this.$emit('reload');
      this.$nextTick(() => {
        (this.$refs['edit-goal-value'] as BModal).hide();
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern der Aufgabe ist etwas schief gelaufen.', 'Oops');
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(apiErrors['nameisNotEmpty'], 'name', 'Bitte einen Ziel Namen eingeben angeben.');
  }

  async cancel() {
    this.model = { ...this.defaultModel() };
  }
}
